// Where the cursor tip (the short step prompt beside the pointer, for example "opposite corner · w,h ⏎") is drawn.
// A size or length readout is drawn at the pointer too (line.ts drawReadout). The tip must never cover it:
// found 2026-10-19 while drawing a rectangle, the prompt hid the width and height. Pure, so a test can try the edges.

export interface Box {
  x: number;
  y: number;
  w: number;
  h: number;
}

const GAP = 2;

const overlaps = (a: Box, b: Box): boolean =>
  a.x < b.x + b.w + GAP && a.x + a.w > b.x - GAP && a.y < b.y + b.h + GAP && a.y + a.h > b.y - GAP;

/**
 * The top-left corner of the tip box. Normally 16 px right and 18 px below the pointer; flipped to the left and above
 * near the right and bottom edges of the canvas; and moved under any readout it would cover (or above the pointer
 * when there is no room under it).
 */
export function placeCursorTip(pointer: { x: number; y: number }, w: number, h: number, cssW: number, cssH: number, readouts: readonly Box[]): { x: number; y: number } {
  let x = pointer.x + 16;
  let y = pointer.y + 18;
  if (x + w > cssW - 4) x = pointer.x - 16 - w; // flip left near the right edge
  if (y + h > cssH - 4) y = pointer.y - 18 - h;
  for (const r of readouts) {
    if (!overlaps({ x, y, w, h }, r)) continue;
    const below = r.y + r.h + 4;
    y = below + h <= cssH - 4 ? below : Math.max(4, pointer.y - 18 - h);
  }
  return { x, y };
}
